import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../error-boundary';

/** The app's error boundary, reset whenever the URL changes.
 *
 * The pathname is handed over as a PROP rather than as a `key`. As a key it
 * remounted everything below it on every navigation — see `ErrorBoundary`'s
 * `resetKey` for what that cost. The reset itself is unchanged: navigating away
 * from a screen that crashed still gives the next one a clean boundary.
 */
export function LocationErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();
  return <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>;
}
